import { render, staticRenderFns } from "./InsuranceTablePlan2.vue?vue&type=template&id=53d7ee18&"
import script from "./InsuranceTablePlan2.vue?vue&type=script&lang=js&"
export * from "./InsuranceTablePlan2.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceTablePlan2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports